import type {
  InventoryListingConfig,
  InventoryListingConfigKeys,
  possibleValueTypes
} from "@dealer-center/ddc-pages-inventory-config-interface";

export interface updateValuesInterface {
  key: InventoryListingConfigKeys;
  value: possibleValueTypes;
}

export function updateValues(
  setCurrentConfig: (value: InventoryListingConfig) => void,
  curentConfig?: InventoryListingConfig
) {
  return ({ key, value }: updateValuesInterface) => {
    if (!curentConfig) {
      return;
    }
    setCurrentConfig({
      ...curentConfig,
      [key]: value
    });
  };
}
